<template>
  <div class="token-body">
    <el-form
      :model="tokenForm"
      :rules="tokenRules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      class="token-form"
    >
      <el-form-item>
        <div class="token-title">批量发送Token</div>
      </el-form-item>

      <el-form-item label="公链" prop="publicChain" class="publicChain">
        <template slot="label">
          <div class="publicChain-label">
            <div class="">
              公链
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">选择其他公链,可在导航右侧进行切换</div>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </div>
        </template>
        <el-input
          v-model="tokenForm.publicChain"
          :disabled="true"
          style="width: 200px"
        ></el-input>
        <!-- <el-select
          v-model="tokenForm.publicChain"
          placeholder="请选择"
          :popper-append-to-body="false"
          :no-data-text="'暂无数据'"
          @change="selectFunction"
          disabled
        >
          <el-option
            v-for="(item, index) in tokenForm.publicChainOptions"
            :key="item.value"
            :label="item.name"
            :value="index"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <!-- <el-form-item label="RPC 节点" prop="node">
        <el-input v-model="tokenForm.node" :disabled="true"></el-input>
      </el-form-item> -->

      <el-form-item label="代币地址" prop="tokenAddress" class="tokenAddress">
        <template slot="label">
          <div class="tokenAddress-label">
            <div class="">
              代币地址
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">请输入代币或粘贴代币地址</div>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
            <span class="token-mark">请选择代币，或粘贴代币合约地址</span>
          </div>
        </template>

        <el-input
          v-model="tokenForm.tokenAddress"
          placeholder="请输入代币或粘贴代币地址"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="查询地址列表:"
        prop="queryAddressList"
        class="queryAddressList"
      >
        <template slot="label">
          <div class="queryAddressList-label">
            <div class="">查询地址列表</div>
            <div
              class="queryAddressList-label-btn"
              v-if="!tokenForm.operationType"
              @click="tokenForm.operationType = true"
            >
              上传文件
            </div>
            <div
              class="queryAddressList-label-btn"
              v-else
              @click="tokenForm.operationType = false"
            >
              手动输入
            </div>
          </div>
        </template>

        <div
          class="queryAddressList-manualInput"
          v-if="!tokenForm.operationType"
        >
          <div class="textarea-container">
            <div class="line-number">
              <div v-for="index in tokenForm.lineNumber" :key="index">
                {{ index }}
              </div>
            </div>
            <textarea
              :style="{ height: tokenForm.lineNumber * 25 + 'px' }"
              v-model="tokenForm.walletAddress"
              class="text-content"
              ref="textarea"
              @input="handleInput"
            ></textarea>
          </div>

          <div class="manualInput-label">
            <div class="">每一行应包括地址和数量，逗号分隔</div>
            <div class="manualInput-label-right" @click="queryExample()">
              查看例子
            </div>
          </div>

          <div class="manualInput-invalid" v-if="tokenForm.checkError">
            <div class="manualInput-label-error">
              <div class="">以下地址或金额不能发送</div>
              <div
                class="manualInput-label-right"
                @click="deleteInvalidAddresses()"
              >
                删除无效地址
              </div>
            </div>

            <div
              :style="{
                height: tokenForm.lineNumberError.length * 25 + 'px',
              }"
              class="text-content-error"
            >
              <div
                v-for="(item, index) in tokenForm.walletAddressError"
                :key="index"
              >
                <span v-if="!regex.test(item)"
                  >第 {{ index + 1 }} 行:
                  {{ item }} 请输入正确的格式，地址和数量以逗号分隔。例:
                  address,number</span
                >
              </div>
            </div>
          </div>
        </div>

        <div
          class="queryAddressList-uploadFiles"
          v-else
          @drop="handleDrop"
          @dragover="handleDragOver"
        >
          <div class="uploadFiles-area" @click="selectUploadFile">
            <img
              fit="contain"
              class="uploadFiles-img"
              @dragstart.prevent
              src="@/assets/images/select_upload.png"
            />
            <input
              type="file"
              ref="uploadFileBtn"
              @input="uploadFile"
              style="display: none"
              multiple
            />
          </div>

          <div class="uploadFiles-label">
            <div class="">支持文件类型：Excel / Txt</div>
            <div class="uploadFiles-label-right" @click="downloadExample()">
              下载例子
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="!tokenForm.checkBalance">
        <el-button
          type="success"
          :disabled="tokenForm.checkError"
          @click="batchQueryBalances()"
          >下一步</el-button
        >
      </el-form-item>

      <el-form-item class="checkBalance" v-if="tokenForm.checkBalance">
        <el-table
          class="checkBalance-table"
          ref="multipleTable"
          :data="balances"
          tooltip-effect="dark"
          style="width: 100%"
          max-height="300"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="id"
            label="ID"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="address"
            label="接收地址"
            min-width="50%"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="数量"
            min-width="30%"
          ></el-table-column>
        </el-table>

        <el-card shadow="always" class="checkBalance-card">
          <div class="card-title">摘要</div>
          <ul class="card-ul">
            <li class="card-li">
              <span class="number">{{ balances.length }}</span>
              <span class="remark">地址总数</span>
            </li>
            <li class="card-li">
              <span class="number"
                >{{ balancesAmount }} {{ tokenForm.symbol }}</span
              >
              <span class="remark">代币发送总额</span>
            </li>
            <li class="card-li">
              <span class="number"
                >{{ balancesTotal }} {{ tokenForm.symbol }}</span
              >
              <span class="remark">代币余额</span>
            </li>
            <li class="card-li">
              <span class="number"
                >{{ balancesTotal }} {{ tokenForm.symbol }}</span
              >
              <span class="remark">你的 ETH 余额</span>
            </li>
          </ul>
        </el-card>

        <div class="checkBalance-btn">
          <el-button type="success" plain @click="toggleSelection(balances, 1)"
            >转账</el-button
          >
          <el-button type="success" @click="toggleSelection(balances, 0)"
            >上一步</el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <!--   Loading   -->
    <LoadingAlert :visible.sync="showLoading"></LoadingAlert>
  </div>
</template>

<script>
import LoadingAlert from "@/components/alert/loading";
import { ethers } from "ethers";
import { nodeConfigs } from "@/config/config.js";
import * as XLSX from "xlsx";
export default {
  components: {
    LoadingAlert,
  },
  data() {
    return {
      tokenForm: {
        node: this.$getChainConfig().rpc, // 节点
        symbol: this.$getChainConfig().symbol,
        publicChain: this.$getChainConfig().name, // 公链下拉选择框
        publicChainOptions: nodeConfigs,
        tokenAddress: "", // 代币地址
        operationType: false, // 操作类型，手动，自动

        fileList: [], // 上传的文件
        fileName: "", // 上传文件的名称
        fileSize: 0, // 上传文件的大小
        fileTime: 0, // 上传文件的时间
        fileType: 0, // 上传文件的类型
        fileTypeName: "", // 上传文件的类型名称

        walletAddress: "", // 合约地址
        walletAddressError: "",
        lineNumber: 1, // 行数
        lineNumberError: 1,
        walletAddressExample:
          "0x460541b2b2F5ADa89D7F58F6B00585d5067f77bA,0.001\n0x5eB26FA7CFe7b1E6bfF20D58AFDd2716E978eB0B,0.001",
        checkError: false, // 检测格式错误
        checkBalance: false, // 检测余额
        radio: "2",
      },
      tokenRules: {},

      regex: /^([a-zA-Z0-9]{42})+(,)+(-?\d+(\.\d+)?)+$/, // 正则判断

      provider: null,
      balances: [],
      balancesTotal: 0, // 余额总值
      balancesAmount: 0, // 数量总值
      multipleSelection: [],

      showLoading: false, // 遮罩层
      LoadingText: "",
      tokenDecimals: null,
    };
  },
  mounted() {
    // 使用Etherscan等公共节点创建一个provider
    console.log("node==", this.tokenForm.node);
    this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);
  },
  methods: {
    // 选择公链
    selectFunction(value) {
      this.tokenForm.node = this.tokenForm.publicChainOptions[value].rpc;
      this.tokenForm.symbol = this.tokenForm.publicChainOptions[value].symbol;
      console.log(this.tokenForm.symbol, this.tokenForm.node);
      this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);

      // 选择公链变化，返回上一步
      if ((this.tokenForm.checkBalance = true)) {
        this.tokenForm.checkBalance = false;
      }
    },
    // 选择上传文件
    selectUploadFile() {
      this.tokenForm.fileList = [];
      this.tokenForm.fileName = "";
      this.tokenForm.fileSize = 0;
      // this.$nextTick(() => {
      //   this.$refs.uploadFileBtn.click();
      // });
      this.$refs.uploadFileBtn.dispatchEvent(new MouseEvent("click"));
    },
    // 拖拽上传
    uploadFile2(files) {
      this.tokenForm.fileList = files;

      if (this.tokenForm.fileList.length <= 0) {
        return;
      }
      this.tokenForm.fileName = this.tokenForm.fileList[0].name;
      this.tokenForm.fileSize = this.tokenForm.fileList[0].size;
      this.tokenForm.fileTime = this.tokenForm.fileList[0].lastModified / 1000;
      this.tokenForm.fileTypeName = this.tokenForm.fileList[0].type;

      if (this.tokenForm.fileName == "") {
        return;
      }

      if (this.tokenForm.fileTypeName == "text/plain") {
        this.readFileContent(this.tokenForm.fileList[0], 0);
      } else if (
        this.tokenForm.fileTypeName ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.readFileContent(this.tokenForm.fileList[0], 1);
      } else {
        this.$message({
          message: "暂只支持文件类型：Excel / Txt",
          type: "warning",
        });
      }
    },
    // 点击上传
    uploadFile(files) {
      this.tokenForm.fileList = files.target.files;

      if (this.tokenForm.fileList.length <= 0) {
        return;
      }
      this.tokenForm.fileName = this.tokenForm.fileList[0].name;
      this.tokenForm.fileSize = this.tokenForm.fileList[0].size;
      this.tokenForm.fileTime = this.tokenForm.fileList[0].lastModified / 1000;
      this.tokenForm.fileTypeName = this.tokenForm.fileList[0].type;
      if (this.tokenForm.fileName == "") {
        return;
      }

      if (this.tokenForm.fileTypeName == "text/plain") {
        this.readFileContent(this.tokenForm.fileList[0], 0);
      } else if (
        this.tokenForm.fileTypeName ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.readFileContent(this.tokenForm.fileList[0], 1);
      } else {
        this.$message({
          message: "暂只支持文件类型：Excel / Txt",
          type: "warning",
        });
      }
    },
    handleDrop(e) {
      e.preventDefault();
      let files = e.dataTransfer.files;
      this.uploadFile2(files);
    },
    handleDragOver(e) {
      e.preventDefault();
    },
    // 获取file内容
    readFileContent(file, type) {
      var that = this;
      const reader = new FileReader();

      if (type == 0) {
        reader.onload = (e) => {
          that.tokenForm.walletAddress = e.target.result;
          that.tokenForm.walletAddress = that.tokenForm.walletAddress.replace(
            /\r/g,
            ""
          );

          that.handleInput();
          that.tokenForm.operationType = false;
        };
        reader.readAsText(file);
      } else if (type == 1) {
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          that.tokenForm.walletAddress = XLSX.utils.sheet_to_txt(worksheet);

          that.handleInput();
          that.tokenForm.operationType = false;
        };
        reader.readAsArrayBuffer(file);
      }
    },
    // textarea
    handleInput() {
      // textarea输入变化，返回上一步
      if ((this.tokenForm.checkBalance = true)) {
        this.tokenForm.checkBalance = false;
      }

      this.tokenForm.walletAddress = [
        ...new Set(this.tokenForm.walletAddress.split("\n")),
      ].join("\n");

      this.tokenForm.lineNumber =
        (this.tokenForm.walletAddress.match(/\n/g) || "").length + 1;

      this.tokenForm.walletAddressError =
        this.tokenForm.walletAddress.split("\n");

      this.tokenForm.lineNumberError = this.tokenForm.walletAddressError;
      this.tokenForm.lineNumberError = this.tokenForm.lineNumberError.filter(
        (lineNumberError) => !lineNumberError.match(this.regex)
      );

      if (this.tokenForm.lineNumberError.length > 0) {
        if (
          this.tokenForm.lineNumberError.length == 1 &&
          this.tokenForm.lineNumber == 1 &&
          this.tokenForm.lineNumberError[0] == ""
        ) {
          this.tokenForm.walletAddressError = "";
          this.tokenForm.checkError = false;
        } else {
          this.tokenForm.checkError = true;
        }
      } else {
        this.tokenForm.checkError = false;
      }
    },
    // 查看例子
    queryExample() {
      this.tokenForm.walletAddress = "";
      this.tokenForm.lineNumber = 1;
      this.tokenForm.walletAddress = this.tokenForm.walletAddressExample;
      this.tokenForm.lineNumber =
        (this.tokenForm.walletAddress.match(/\n/g) || "").length + 1;

      this.handleInput();
    },
    // 删除无效地址
    deleteInvalidAddresses() {
      this.tokenForm.walletAddress = this.tokenForm.walletAddress.split("\n");
      this.tokenForm.walletAddress = this.tokenForm.walletAddress.filter(
        (walletAddress) => this.regex.test(walletAddress)
      );

      this.tokenForm.lineNumber = (this.tokenForm.walletAddress || "").length;

      var tempContractAddress = "";
      for (var i = 0; i < this.tokenForm.walletAddress.length; i++) {
        tempContractAddress += this.tokenForm.walletAddress[i] + "\n";
      }
      this.tokenForm.walletAddress = tempContractAddress;
      this.tokenForm.walletAddressError = "";
      this.tokenForm.checkError = false;
    },
    // 下一步
    async batchQueryBalances() {
      if (this.tokenForm.tokenAddress == "") {
        this.$message.warning("请输入代币或粘贴代币地址");
        return;
      }

      if (this.tokenForm.walletAddress.length == 0) {
        this.$message.warning("请至少输入一条地址信息");
        return;
      }

      this.showLoading = true;

      if (this.tokenForm.tokenAddress != "") {
        const code = await this.provider.getCode(this.tokenForm.tokenAddress);
        //console.log("getCode===", code);
        if (code == "0x") {
          this.showLoading = false;
          this.$message.error(
            "代币地址不存在，请检查代币发布网络与当前所选主链是否匹配"
          );
          return;
        }
        // 接收地址list
        var list = this.tokenForm.walletAddress.split("\n");
        // 清空初始数据
        this.balances = [];
        this.balancesTotal = 0;
        this.balancesAmount = 0;
        // 查询自己钱包余额
        const balance = await this.getABIAndBalance(
          this.tokenForm.tokenAddress,
          localStorage.getItem("TokenBox-account")
        );
        var balanceInEther = -1;
        if (balance == null) {
          balanceInEther = -1;
        } else {
          balanceInEther = parseFloat(ethers.utils.formatEther(balance));
        }
        // 余额总和
        if (parseFloat(balanceInEther) >= 0) {
          this.balancesTotal = parseFloat(balanceInEther);
        }

        for (let i = 0; i < list.length; i++) {
          const item = {
            id: i + 1,
            address: list[i].split(",")[0],
            amount: list[i].split(",")[1],
          };
          this.balances.push(item);

          // 数量总和
          this.balancesAmount =
            this.balancesAmount + parseFloat(list[i].split(",")[1]);

          this.tokenForm.checkBalance = true;
          if (i == list.length - 1) {
            this.showLoading = false;
          }
        }
      }
    },
    async getABIAndBalance(contractAddress, walletAddress) {
      try {
        // 获取合约ABI
        var abi = [
          {
            constant: true,
            inputs: [
              {
                name: "_owner",
                type: "address",
              },
            ],
            name: "balanceOf",
            outputs: [
              {
                name: "balance",
                type: "uint256",
              },
            ],
            payable: false,
            stateMutability: "view",
            type: "function",
          },
        ];
        // 使用获取的ABI创建合约实例
        const contract = new ethers.Contract(
          contractAddress,
          abi,
          this.provider
        );

        const balance = await contract.balanceOf(walletAddress);
        return balance;
      } catch (error) {
        this.$showErrorMessage(error);
        return null;
      }
    },
    // 转账
    async batchTransferTokens() {
      this.showLoading = true;
      if (!window.ethereum) {
        this.$showErrorMessage("当前环境未安装钱包");
      }
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      const tokenContractAddress = this.tokenForm.tokenAddress;

      const tokenABI = [
        {
          constant: true,
          inputs: [],
          name: "decimals",
          outputs: [
            {
              name: "",
              type: "uint8",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            {
              name: "_to",
              type: "address",
            },
            {
              name: "_value",
              type: "uint256",
            },
          ],
          name: "transfer",
          outputs: [
            {
              name: "success",
              type: "bool",
            },
          ],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
      ];
      const tokenContract = new ethers.Contract(
        tokenContractAddress,
        tokenABI,
        signer
      );

      try {
        const decimals = await tokenContract.decimals();
        this.tokenDecimals = decimals;
      } catch (error) {
        console.error("查询 Token 精度出错:", error);
      }
      // 接收地址list
      var list = this.tokenForm.walletAddress.split("\n");
      for (let i = 0; i < list.length; i++) {
        try {
          const transferTx = await tokenContract.transfer(
            list[i].split(",")[0],
            ethers.utils.parseUnits(list[i].split(",")[1], this.tokenDecimals)
          );
          await transferTx.wait();

          this.$message.success(
            `Successfully transferred ${list[i].split(",")[1]} tokens to ${
              list[i].split(",")[0]
            }`
          );
          console.log(
            `Successfully transferred ${list[i].split(",")[1]} tokens to ${
              list[i].split(",")[0]
            }`
          );

          this.showLoading = false;
        } catch (error) {
          this.$showErrorMessage(error);
          this.showLoading = false;
        }
      }
    },
    toggleSelection(rows, index) {
      if (rows) {
        if (index == 0) {
          this.tokenForm.checkBalance = false;
        } else if (index == 1) {
          this.batchTransferTokens();
        }
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 下载示例
    downloadExample() {
      this.tokenForm.walletAddressExample =
        this.tokenForm.walletAddressExample.split("\n");
      var tempWalletAddressExample = [];
      for (var i = 0; i < this.tokenForm.walletAddressExample.length; i++) {
        const item = {
          address: this.tokenForm.walletAddressExample[i],
        };
        tempWalletAddressExample.push(item);
      }

      const data = tempWalletAddressExample.map((item) => ({
        address: item.address,
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "example_address.xlsx");
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 30%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 15% 0 15%;

  .token-form {
    width: 100%;
    margin: 20px 0 0 0;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 4% 0 0 0;
    }

    .token-node {
      font-weight: normal;
      font-size: 18px;
      color: #8f8f8f;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 54px 0 0 0;
    }

    /deep/.el-input__inner {
      height: 46px;

      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-textarea__inner {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input__count {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-form-item__label {
      font-weight: normal;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input-group__append {
      background: #3d3d3d;
      border-radius: 0px 4px 4px 0px;
      border: none;

      font-weight: normal;
      font-size: 16px;
      color: #939393;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-select-dropdown {
      width: 198px;
      // background: #d9d9d9;
      border-radius: 8px 8px 8px 8px;
      font-weight: 400;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      top: 65px !important;
    }
    /deep/.el-select-dropdown__item:hover {
      background: rgba(77, 77, 77, 0.5);
      color: #d8d8d8;
    }
    /deep/.el-select-dropdown__item.selected {
      color: #675aff;
    }
    /deep/.popper__arrow {
      left: 93px !important;
    }

    .token-handlingFees {
      display: flex;
      align-items: center;
      margin: 0 0 20px 0;

      /deep/.el-input-group__prepend {
        display: table-row;
        font-weight: normal;
        font-size: 14px;
        color: #8f8f8f;
        line-height: 2.7em;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: transparent;
        border: none;
      }
    }

    .token-optionalContent {
      span {
        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 0 0 0 12px;
        cursor: pointer;
      }
    }

    .token-alert {
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .publicChain {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
      }

      .publicChain-label {
        width: 100%;
        max-width: 215px;
        white-space: nowrap;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .tokenAddress {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
      }

      .tokenAddress-label {
        width: 100%;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .token-mark {
          font-weight: normal;
          font-size: 12px;
          color: #6e6e6e;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .queryAddressList {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
      }

      .queryAddressList-label {
        width: 100%;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .queryAddressList-label-btn {
          width: 100px;
          height: 23px;
          background: #4438d4;
          border-radius: 15px 15px 15px 15px;
          border: 1px solid #695cff;

          font-weight: normal;
          font-size: 14px;
          color: #ffffff;
          line-height: 23px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
        .queryAddressList-label-btn:hover {
          border: 1px solid #aba4ff;
        }
      }

      .queryAddressList-manualInput {
        .textarea-container {
          display: flex;
          align-items: flex-start;
          height: 180px;
          overflow: auto;

          background: #292929;
          border-radius: 4px 4px 4px 4px;

          .line-number {
            width: 25px;
            height: auto;
            min-height: 180px;
            font-weight: normal;
            font-size: 14px;
            color: #8f8f8f;
            line-height: 25px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            background: rgba(77, 77, 77, 0.5);

            margin-right: 10px;
            padding: 2px;
          }

          .text-content {
            height: 100%;
            min-height: 180px;
            flex: 1;

            background: #292929;
            border: none;
            font-weight: normal;
            font-size: 14px;
            color: #ffffff;
            line-height: 25px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            letter-spacing: 0.05em;
          }
        }

        .manualInput-label {
          display: flex;
          justify-content: space-between;
          align-items: center;

          font-weight: normal;
          font-size: 14px;
          color: #8f8f8f;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 10px 0 0 0;

          .manualInput-label-right {
            width: 100px;
            height: 23px;
            background: #4438d4;
            border-radius: 15px 15px 15px 15px;
            border: 1px solid #695cff;

            font-weight: normal;
            font-size: 14px;
            color: #ffffff;
            line-height: 23px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
          }
          .manualInput-label-right:hover {
            border: 1px solid #aba4ff;
          }
        }

        .manualInput-invalid {
          width: 100%;
          height: auto;

          .manualInput-label-error {
            display: flex;
            justify-content: space-between;
            align-items: center;

            font-weight: normal;
            font-size: 14px;
            color: #c90303;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 40px 0 0 0;

            .manualInput-label-right {
              width: 100px;
              height: 23px;
              background: #4438d4;
              border-radius: 15px 15px 15px 15px;
              border: 1px solid #695cff;

              font-weight: normal;
              font-size: 14px;
              color: #ffffff;
              line-height: 23px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              cursor: pointer;
            }
            .manualInput-label-right:hover {
              border: 1px solid #aba4ff;
            }
          }

          .text-content-error {
            width: calc(100% - 70px);
            height: 100%;
            flex: 1;

            background: #292929;
            border: none;
            font-weight: normal;
            font-size: 14px;
            color: #ffffff;
            line-height: 25px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            letter-spacing: 0.05em;
            padding: 20px 35px 20px 35px;
            border-radius: 4px 4px 4px 4px;
            margin: 10px 0 0 0;

            display: flex;
            flex-direction: column;
            overflow: auto;
          }
        }
      }

      .queryAddressList-uploadFiles {
        .uploadFiles-area {
          display: flex;
          align-items: center;
          justify-content: center;
          width: auto;
          height: 180px;
          background: #292929;
          border-radius: 4px 4px 4px 4px;
          cursor: pointer;

          .uploadFiles-img {
            width: 140px;
            height: 36px;
          }
        }
        .uploadFiles-area:hover {
          background: rgba(77, 77, 77, 0.5);
        }

        .uploadFiles-label {
          display: flex;
          justify-content: space-between;
          align-items: center;

          font-weight: normal;
          font-size: 14px;
          color: #8f8f8f;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 10px 0 0 0;

          .uploadFiles-label-right {
            width: 100px;
            height: 23px;
            background: #4438d4;
            border-radius: 15px 15px 15px 15px;
            border: 1px solid #695cff;

            font-weight: normal;
            font-size: 14px;
            color: #ffffff;
            line-height: 23px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            cursor: pointer;
          }
          .uploadFiles-label-right:hover {
            border: 1px solid #aba4ff;
          }
        }
      }
    }

    .checkBalance {
      margin-bottom: 20px;
      .checkBalance-label {
        font-weight: normal;
        font-size: 14px;
        color: #8f8f8f;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        padding: 0 0 10px 0;
      }

      .checkBalance-table {
        margin: 0 0 10px 0;

        /deep/.el-table__cell {
          text-align: center;
        }

        /* 为所有滚动条设置样式 */
        ::-webkit-scrollbar {
          width: 6px; /* 设置滚动条的宽度 */
          height: 10px; /* 设置滚动条的高度 */
        }

        /* 滚动条轨道 */
        ::-webkit-scrollbar-track {
          background: transparent; /* 设置轨道的背景颜色 */
        }

        /* 滚动条的滑块 */
        ::-webkit-scrollbar-thumb {
          background: #888; /* 设置滑块的背景颜色 */
          border-radius: 5px 5px;
        }

        /* 当鼠标悬停在滑块上 */
        ::-webkit-scrollbar-thumb:hover {
          background: #555; /* 设置滑块在悬停状态下的背景颜色 */
          cursor: pointer;
        }
      }

      .checkBalance-card {
        margin: 0 0 20px 0;
        text-align: center;

        .card-title {
          font-weight: normal;
          font-size: 20px;
          color: #8f8f8f;
          line-height: 23px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .card-ul {
          display: flex;
          flex-wrap: wrap;

          .card-li {
            width: 30%;
            display: flex;
            flex-direction: column;
            text-align: left;
            padding: 1% 10%;

            .number {
              font-size: 20px;
              line-height: 2em;
              color: #606266;
              font-weight: 500;
            }
            .remark {
              font-size: 12px;
              line-height: 1em;
              color: #909399;
            }
          }
        }
      }

      .checkBalance-radio {
        margin: 0 0 20px 0;
      }

      .checkBalance-btn {
        margin: 0 0 54px 0;
      }
    }
  }
}
/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>